import { formatUsd } from "../../config/trading";
import { EarningsMonitor } from "../trading/EarningsMonitor";
import { TradingAnalysisMonitor } from "../trading/TradingAnalysisMonitor";

export function ViewerSummaryPage({ dashboard }) {
  return (
    <main className="terminal-shell" data-testid="viewer-summary-page">
      <section className="panel">
        <span className="label">VIEWER SUMMARY</span>
        <h1>Account Snapshot</h1>
        <div className="metrics-grid">
          <div className="metric" data-testid="viewer-total-value"><span className="label">Portfolio</span><strong>{formatUsd(dashboard.portfolio.total_value_usdt)}</strong></div>
          <div className="metric" data-testid="viewer-usdt"><span className="label">USDT</span><strong>{formatUsd(dashboard.portfolio.available_usdt)}</strong></div>
          <div className="metric" data-testid="viewer-pnl"><span className="label">Paper PnL</span><strong>{formatUsd(dashboard.portfolio.paper_pnl_usdt)}</strong></div>
          <div className="metric" data-testid="viewer-automation"><span className="label">Automation</span><strong>{dashboard.live_automation.enabled ? "Running" : "Stopped"}</strong></div>
        </div>
      </section>
      <section className="single-grid"><EarningsMonitor earnings={dashboard.earnings} /></section>
      <section className="single-grid"><TradingAnalysisMonitor analysis={dashboard.trading_analysis} /></section>
    </main>
  );
}